import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, FileUpload, Toast, InputTextarea, Dropdown, RadioButton } from "primereact";
import { Formik } from "formik";
import "../../assets/css/badge.css";
import Moment from "moment";
import MultiLanguageEditor from "../MultiLanguageEditor";
import { getMultiLngInitValue, validateMultiLanguageEditor } from "../../util";
import * as Yup from "yup";

class ListaLotti extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (e) => {
          this.vai(e, "V");
          console.log("View");
        },
      },
    ];
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      imgsrc: "",
      lotti: [],
      listastabilimento: [],
      languages: "",
      activePage: 1,
      singolo: {},
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      rows: 10,
      visible1: false,
      visible2: false,
      visible3: false,
      loading: true,
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
    this.lottoid = 0;
  }
  componentDidMount() {
    this.prodottoid = this.props.prodottoid;
    this.caricaDati(1, this.state.pageSize);
    this.stato = this.props.stato;
    if (this.stato == "U") {
      this.actions.push(
        {
          id: 2,
          icon: "pi-pencil",
          label: "",
          action: (id) => {
            this.vai(id, "U");
            console.log("Update " + id);
          },
        },
        {
          id: 3,
          icon: "pi-trash",
          label: "",
          action: (id) => {
            this.vai(id, "D");
            console.log("Delete " + id);
          },
        },
        {
          id: 4,
          icon: "pi-cog",
          label: "",
          action: (id) => {
            console.log("Delete " + id);
          },
        },
      );
    }
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&prodottoid=" + this.prodottoid;
    axios
      .get(Costanti.UrlCallApi + "lotti/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });

        this.setState({ lotti: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });

    axios
      .get(Costanti.UrlCallApi + "stabilimento/all?page=1&num=10000&aziendaid=" + this.utente.aziendaid, config)
      .then((res) => {
        this.setState({ listastabilimento: res.data.lista1, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });

    axios
      .get(Costanti.UrlCallApi + "azienda/lingue/" + this.utente.aziendaid, config)
      .then((res) => {
        this.setState({ languages: res.data, loading: false });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "lotti/" + id, config)
      .then((res) => {
        this.setState({
          singolo: res.data,
          loading: false,
          imgsrc: Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/lotto/" + id,
        });
        this.lottoid = id;
      })
      .catch((error) => {
        alert(error);
        this.lottoid = 0;
      });
  }

  settaImg() {
    var testo =
      Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/lotto/" + this.lottoid + "?" + Math.random();
    this.setState({ imgsrc: testo });
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }
  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  setVisible2(val) {
    this.setState({ visible2: val });
    //this.caricaDati(this.state.activePage,this.state.pageSize);
  }
  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Lotto" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Lotto" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Lotto" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Lotto" });
        break;
    }
  }
  salva2(values) {
    this.showMessage("success", "Dati salvati correttamente", "");
    this.setVisible2(false);
  }
  async salva(values) {
    try {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.setState({ isSubmitting: true });
      if (this.state.tipo == "D") {
        values.status = "E";
        await axios.post(Costanti.UrlCallApi + "lotti/salva/" + this.state.singolo.id, values, config);
      }
      if (this.state.tipo == "U") {
        await axios.post(Costanti.UrlCallApi + "lotti/salva/" + this.state.singolo.id, values, config);
      }
      if (this.state.tipo == "A") {
        var dato = {
          datains: null,
          dataupd: null,
          id: 0,
          numero: values.numero,
          prodottoid: this.prodottoid,
          uteins: 1,
          uteupd: null,
          traduzione: values.traduzione,
          data1: values.data1,
          data2: values.data2,
          stabilimentoid: values.stabilimentoid,
          status: " ",
        };
        await axios.post(Costanti.UrlCallApi + "lotti/aggiungi", dato, config);
      }
      this.showMessage("success", "Dati salvati correttamente", "");
      this.setState({ isSubmitting: false });
      this.setVisible1(false);
    } catch (error) {
      this.showMessage("error", "Errore nel salvataggio", error.message);
      this.setState({ isSubmitting: false });
      this.setVisible1(false);
    }
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/lotti/" + this.prodottoid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  getLotto(id) {
    let descrizione = "";
    this.state.lotti.forEach((element) => {
      if (element.id == id) {
        const traduzione = element.traduzione;
        descrizione =
          traduzione.length > 0 && traduzione.find((el) => el.nomecampo === "descrizione" && el.lingua === "it");

        descrizione = descrizione ? descrizione.testo : "";
      }
    });
    return descrizione;
  }

  getStabilimentoName(id) {
    let name = "";
    this.state.listastabilimento.forEach((element) => {
      if (element.id == id) {
        name = element.nome;
      }
    });
    return name;
  }

  // Function that returns a Yup schema with the custom validation
  multiLanguageEditor = (languages) => {
    return Yup.array()
      .required("Campo richiesto per tutte le lingue")
      .test({
        name: "multiLanguageEditor",
        message: "Campo richiesto per tutte le lingue",
        test: (value) => validateMultiLanguageEditor(value, languages) === undefined,
      });
  };

  validationSchema(languages) {
    return Yup.object().shape({
      traduzione: this.multiLanguageEditor(languages),
    });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          emptyMessage={<div className="flex w-full justify-content-center font-bold ">NO DATA FOUND</div>}
          value={this.state.lotti}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Lotti</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              {this.stato == "U" ? (
                <>
              
                  {/*<Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/> */}
                  <Button
                    label="Aggiungi"
                    onClick={() => this.vai(0, "A")}
                    icon="pi pi-plus"
                    className="p-button-rounded p-button-primary "
                  />
                </>
              ) : (
                ""
              )}
            </div>
          }
          responsiveLayout="stack"
        >
          <Column
            id="id0"
            header=""
            body={(item) => (
              <img
                src={Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/lotto/" + item.id}
                style={{ maxHeight: "100px", maxWidth: "100px" }}
                alt=""
                className="mr-4"
              />
            )}
          />
          <Column id="id2" field="numero" header="Numero" />
          {/*<Column id="id3" field="codice" header="Codice Annata" />*/}
          <Column
            id="id3"
            header={sessionStorage.getItem("DecoLotto1")}
            body={(item) => <span> {item.data1 ? Moment(new Date(item.data1)).format("yyyy-MM-DD") : ""}</span>}
          />
          <Column
            id="id3a"
            header={sessionStorage.getItem("DecoLotto2")}
            body={(item) => <span> {item.data2 ? Moment(new Date(item.data2)).format("yyyy-MM-DD") : ""}</span>}
          />
          <Column
            id="id4"
            header={sessionStorage.getItem("DecoStabilimento")}
            body={(item) => this.getStabilimentoName(item.stabilimentoid)}
          />
          <Column id="id4a" field="descrizione" header="Descrizione" body={(item) => this.getLotto(item.id)} />
          {sessionStorage.getItem("LottoCliente") != "" ? (
            <Column
              id="id4a"
              header="Lotti Clienti"
              body={(item) => (
                <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                  <Button label="111" className="p-button-outlined p-button-success" />
                  <Button label="345" className="p-button-outlined p-button-success" />
                  <Button
                    icon="pi pi-plus-circle"
                    onClick={() => this.setVisible2(true)}
                    className="p-button-rounded p-button-warning p-button-outlined"
                    aria-label="Aggiungi"
                  />
                </div>
              )}
            ></Column>
          ) : (
            <Column id="id4a"></Column>
          )}

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>
        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="border-top-1 surface-border pt-4 col-12">
            <div className="surface-card p-2  border-round">
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                  status: this.state.singolo.status,
                  numero: this.state.singolo.numero,
                  descrizione: this.state.singolo.descrizione,
                  descrizioneen: this.state.singolo.descrizioneen,
                  stabilimentoid: this.state.singolo.stabilimentoid,
                  traduzione: this.state.singolo.traduzione,

                  data1: this.state.singolo.data1
                    ? Moment(new Date(this.state.singolo.data1)).format("yyyy-MM-DD")
                    : null,
                  data2: this.state.singolo.data2
                    ? Moment(new Date(this.state.singolo.data2)).format("yyyy-MM-DD")
                    : null,
                  prodottoid: this.prodottoid,
                }}
                enableReinitialize
                validationSchema={() => this.validationSchema(this.state.languages)}
                onSubmit={(values) => {
                  this.salva(values);
                }}
              >
                {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="grid formgrid p-fluid">
                        <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                        <div className="field mb-1 col-12 md:col-6">
                          <label htmlFor="numero" className="font-medium text-600">
                            Numero lotto
                          </label>
                          <InputText
                            id="numero"
                            name="numero"
                            readOnly={!this.state.editMode}
                            value={values.numero ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="text"
                          />
                        </div>
                        <div className="field mb-1 col-12 md:col-6">
                          <label htmlFor="data1" className="font-medium text-600">
                            {sessionStorage.getItem("DecoLotto1")}{" "}
                          </label>
                          <InputText
                            id="data1"
                            name="data1"
                            type="date"
                            value={values.data1 ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                        <div className="field mb-1 col-12 md:col-6">
                          <label htmlFor="data2" className="font-medium text-600">
                            {sessionStorage.getItem("DecoLotto2")}{" "}
                          </label>
                          <InputText
                            id="data2"
                            name="data2"
                            type="date"
                            value={values.data2 ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                        <div className="field mb-1 col-12 md:col-6">
                          <label htmlFor="nickname2" className="font-medium text-600">
                            {sessionStorage.getItem("DecoStabilimento")}{" "}
                          </label>
                          <Dropdown
                            optionLabel="nome"
                            options={this.state.listastabilimento}
                            optionValue="id"
                            value={values.stabilimentoid}
                            onChange={(e) => setFieldValue("stabilimentoid", e.value)}
                            placeholder="Seleziona ..."
                          />
                        </div>
                        {this.lottoid > 0 ? (
                          <div className="mt-2 flex w-full justify-content-start col-12">
                            <div className="field mb-1 col-12 md:col-6">
                              <label htmlFor="avatar2" className="font-medium text-600">
                                Multimedia
                              </label>
                              <div className="flex align-items-start">
                                {this.state.imgsrc ? (
                                  <img src={this.state.imgsrc} width="20%" alt="" className="mr-4" />
                                ) : (
                                  <FileUpload
                                    id="avatar2"
                                    mode="basic"
                                    name="avatar"
                                    url={
                                      Costanti.UrlCallApi +
                                      "file/carica/" +
                                      this.utente.aziendaid +
                                      "/lotto/" +
                                      this.lottoid
                                    }
                                    onError={() =>
                                      this.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")
                                    }
                                    onUpload={() => this.settaImg()}
                                    accept="image/*"
                                    maxFileSize={10000000}
                                    chooseOptions={{ className: "p-button-plain p-button-outlined" }}
                                    chooseLabel="Upload Image"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="flex field mb-1 col-12 md:col-12">
                          <MultiLanguageEditor
                            label={"Descrizione"}
                            type="text-area"
                            languages={this.state.languages}
                            content={getMultiLngInitValue(
                              "lotti",
                              "descrizione",
                              this.state.languages,
                              values.traduzione,
                            )}
                            isReadOnly={this.state.tipo === "V" || this.state.tipo === "D"}
                            fieldName={"traduzione"}
                            setValue={setFieldValue}
                            isAddItem={this.state.tipo === "A"}
                            error={errors.traduzione}
                          />
                        </div>
                      </div>

                      <footer>
                        <div className="flex flex-row gap-2 border-top-1 surface-border pt-3">
                          <Button
                            type="submit"
                            visible={this.state.tipo == "U"}
                            icon="pi pi-save"
                            label="Salva"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            visible={this.state.tipo == "A"}
                            icon="pi pi-save"
                            label="Aggiungi"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            visible={this.state.tipo == "D"}
                            icon="pi pi-save"
                            label="Elimina"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            type="button"
                            className="pi p-button-outlined"
                            onClick={() => this.setVisible1(false)}
                            label="Annulla"
                          />
                        </div>
                      </footer>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Dati aggiuntivi"
          closable={false}
          visible={this.state.visible2}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <Formik
                initialValues={{
                  status: this.state.singolo.status,
                  numero: this.state.singolo.numero,
                  descrizione: this.state.singolo.descrizione,
                  descrizioneen: this.state.singolo.descrizioneen,
                  stabilimentoid: this.state.singolo.stabilimentoid,

                  data1: this.state.singolo.data1
                    ? Moment(new Date(this.state.singolo.data1)).format("yyyy-MM-DD")
                    : null,
                  data2: this.state.singolo.data2
                    ? Moment(new Date(this.state.singolo.data2)).format("yyyy-MM-DD")
                    : null,
                  prodottoid: this.prodottoid,
                }}
                enableReinitialize
                validationSchema={this.validationSchema}
                onSubmit={(values) => {
                  this.salva2(values);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap border-top-1 surface-border pt-4">
                      <div className="surface-card p-2  border-round">
                        <div className="grid formgrid p-fluid">
                          <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="numero" className="font-medium text-600">
                              Numero lotto Cliente
                            </label>
                            <InputText
                              id="numero"
                              name="numero"
                              readOnly={!this.state.editMode}
                              value={values.numero}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              type="text"
                            />
                          </div>
                          <div className="field mb-1 col-12 md:col-6">
                            <label htmlFor="nickname2" className="font-medium text-600">
                              Lista Clienti
                            </label>
                            <Dropdown
                              optionLabel="nome"
                              options={this.state.listastabilimento}
                              optionValue="id"
                              value={values.stabilimentoid}
                              onChange={(e) => setFieldValue("stabilimentoid", e.value)}
                              placeholder="Seleziona ..."
                            />
                          </div>
                          <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                          <div className="field mb-1 col-12 md:col-12">
                            <label htmlFor="descrizione" className="font-medium text-600">
                              Descrizione
                            </label>
                            <InputTextarea
                              id="descrizione"
                              type="text"
                              rows={10}
                              autoResize
                              value={values.descrizione}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <footer>
                      <div className="flex flex-row  border-top-1 surface-border pt-3">
                        <Button type="submit" visible={this.state.tipo == "U"} icon="pi pi-save" label="Salva" />
                        <Button visible={this.state.tipo == "A"} icon="pi pi-save" label="Aggiungi" />
                        <Button visible={this.state.tipo == "D"} icon="pi pi-save" label="Elimina" />
                        <Button
                          type="button"
                          icon="pi pi-check"
                          onClick={() => this.setVisible2(false)}
                          label="Chiudi"
                        />
                      </div>
                    </footer>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaLotti;
